import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { setSkippedAd } from "../../../redux/slices/LcaSlice";
import axiosClient from "../../../axios-client";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import Select from "react-select"; // Ensure react-select is imported
import { fetchBWV } from "../Data";

const SkipModal = ({ open, close, ad }) => {
  const userinfo = useSelector((state) => state.user.userInfo);
  const islogin = useSelector((state) => state.user.isLogin);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [skipReason, setSkipReason] = useState(0);
  const [service, setService] = useState(null);
  const [comment, setComment] = useState("");
  const isAdmin = user && user.Role === "admin";
  const [allServices, setAllServices] = useState([]);
  const dispatch = useDispatch();
  const skipTypes = {
    1: "Customer Not Desired",
    2: "Already Booked on Date",
    3: "Other",
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const bwvData = await fetchBWV();
      const filterActive = bwvData.filter((vendor) => vendor.isactive === "3");
      setAllServices(filterActive);
    } catch (error) {
      toast.error("Failed to fetch providers");
    }
  };

  const options =
    allServices
      ?.map((list) => {
        const option = {
          value: JSON.stringify(list),
          label: `${list.listName} ${
            list.FullName ? `(${list.FullName})` : ""
          }`,
        };
        return option;
      })
      .sort((a, b) => a.label.localeCompare(b.label)) || [];

  console.log("Options:", options);

  const handleSkipReasonChange = (e) => {
    const value = parseInt(e.target.value);
    setSkipReason(value);
    if (value !== 3) {
      setComment("");
    }
    if (value === 0) {
      setComment("");
    }
  };

  const handleConfirmSkip = async () => {
    if (!islogin) {
      toast.info("Please Login To Skip Customer!");
      return;
    }

    if (!ad?.Id) {
      toast.error("Invalid ad ID");
      return;
    }
    console.log(service, "service");
    let createdBy;
    try {
      createdBy = service.createdBy || user?.UserID;
      if (!createdBy) {
        toast.error("Invalid user ID");
        return;
      }
    } catch (parseError) {
      toast.error("Invalid provider data");
      console.error("Service parse error:", parseError);
      return;
    }

    try {
      const formData = {
        needId: ad.Id,
        skipStatus: 1,
        createdBy,
        skipReason: skipReason,
        comment: skipReason === 3 ? comment : undefined,
      };
      console.log("formData:", formData);
      const response = await axiosClient.post("need/SkipCustomer", formData);
      if (response.data.statusCode === 200) {
        dispatch(
          setSkippedAd({
            ...ad,
            needSkipCustomer: 1,
          })
        );
        toast.success("Ad skipped successfully!");
        close();
      } else {
        toast.error(response.data.msg || "Failed to skip ad");
      }
    } catch (error) {
      console.error("Error skipping ad:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        request: error.request,
      });
      toast.error(
        "Error skipping ad: " + (error.response?.data?.msg || error.message)
      );
    }
  };

  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const handleClose = () => {
    setSkipReason(0);
    setService(null);
    setComment("");
    close();
  };

  const isSkipDisabled =
    skipReason === 0 || (skipReason === 3 && comment.trim() === "");

  return (
    <React.Fragment>
      <Dialog
        fullWidth
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Skip {ad.Title}</DialogTitle>
        <DialogContent>
          <div className="d-flex flex-column gap-2">
            {isAdmin && (
              <>
                <label htmlFor="provider">
                  Select Provider To Skip{" "}
                  {/* <span style={{ color: "red" }}>*</span> */}
                </label>
                <Select
                  options={options}
                  onChange={(selectedOption) => {
                    if (selectedOption) {
                      setService(JSON.parse(selectedOption.value));
                    } else {
                      setService(null);
                    }
                  }}
                  placeholder="Select Provider To Skip"
                  isSearchable
                  isClearable
                />
              </>
            )}
            <label htmlFor="skip-reason">
              Skip Reason <span style={{ color: "red" }}>*</span>
            </label>
            <select
              id="skip-reason"
              className="form-select"
              name="skipReason"
              value={skipReason}
              onChange={handleSkipReasonChange}
            >
              <option value={0} disabled>
                Select Reason
              </option>
              {Object.entries(skipTypes).map(([key, value]) => (
                <option key={key} value={key}>
                  {value}
                </option>
              ))}
            </select>

            {skipReason === 3 && (
              <div className="mt-3">
                <label htmlFor="comment">
                  Comment <span style={{ color: "red" }}>*</span>
                </label>
                <textarea
                  id="comment"
                  className="form-control"
                  value={comment}
                  onChange={handleCommentChange}
                  placeholder="Enter your comment"
                  rows={4}
                />
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={handleConfirmSkip}
            disabled={isSkipDisabled}
            autoFocus
          >
            Skip
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default SkipModal;
